<template>
  <div>
     <div class="nav-head">
        <van-nav-bar :title='title'>
          <template #left >
            <!-- <img src="@/assets/redlist.png" @click="showPopup"  class="iconList" > -->
            <img src="@/assets/caidan.png" @click="showPopup"  class="iconList" >
          </template>
          <template #right>
            <!-- 图标 加入购物车 -->
            <img src="@/assets/search.png"  @click="showCart" class="iconList" style="width:18px;height:18px">
          </template>
        </van-nav-bar>
        <!-- <language></language> -->
        <van-popup v-model="show"  position="left" :style="{ height: '100%' ,width:'50%'}" closeable>
            <div class="send">
              <van-dropdown-menu v-if="isShow">
                  <van-dropdown-item v-model="send" :options="sendItems" @change="changePay(sendItems[send].text,sendItems[send].value)" />
              </van-dropdown-menu>
            </div>
            <div class="ld">
              <van-button type="default" @click="onHome" >{{$t('index.index')}}</van-button>
              <el-col :span="12">
                <el-menu
                  default-active="2"
                  class="el-menu-vertical-demo"
                  @open="handleOpen"
                  @close="handleClose">
                  <el-submenu :index="item.categoryId+''" v-for="(item,index) in itemList" :key="index" :class="{shows:item.children!=null}">
                    <template slot="title" >
                      <span @click.stop="onNavBar(item.categoryId)"  v-if="item.children!=null" >{{item.categoryName}} </span>
                      <div @click.stop="onNavBar(item.categoryId)" v-else>{{item.categoryName}}</div>
                      <!-- <van-tag round type="primary" @click.stop="onNavBar(item.categoryId)">点击进入</van-tag> -->
                    </template>
               
                    <el-submenu :index="items.categoryId+''"  v-for="(items,indexs) in item.children" :key="indexs" :class="{heid:items.children==null}">
                      <template slot="title" >
                        <span @click.stop="onNavBar(items.categoryId)"  v-if="items.children!=null">{{items.categoryName}}</span>
                        <div @click.stop="onNavBar(items.categoryId)" v-else>{{items.categoryName}}</div>
                        <!-- <van-tag round type="primary" @click.stop="onNavBar(items.categoryId)">点击进入</van-tag>   -->
                      </template>
                      <el-menu-item :index="itemss.categoryId+''" v-for="(itemss,indexss) in items.children" :key="indexss"  >
                        <span @click.stop="onNavBar(itemss.categoryId)" >{{itemss.categoryName }}</span>
                        <!-- <van-tag round type="primary" @click.stop="onNavBar(itemss.categoryId)">点击进入</van-tag> -->
                      </el-menu-item>
                    </el-submenu>
                  </el-submenu>
                </el-menu>
              </el-col>
            </div>

        </van-popup>
        <div class="on-width">
          <div @click="onTop" class="on-top" style="position: absolute;">
                <!-- <van-icon class="el-icon-caret-top"  size="30px"/> -->
                <img src="@/assets/redtop.png" alt="">
          </div>
          <div @click="gohome" class="on-top" style="position: absolute;bottom: 0%;">
                <img src="@/assets/rednews.png" alt="">
          </div>
        </div>
     </div>
      
      
      <div class="bodys">
          <router-view :datass='changeItem' ref="setRegion" ></router-view>
      </div>
  </div>
</template>
<script>
    // zE('webWidget', 'show');
</script>
<script>
import { NavBar ,DropdownMenu, DropdownItem,TreeSelect,Button,Dialog} from 'vant';
import { mapMutations, mapState } from 'vuex';
import { findIndex, remove, cloneDeep } from 'lodash';
import language from "../index/common/Language";
import goods from '@/api/goods';
import home from '@/api/home';
import { treeDataTranslate } from "@/utils/index";
import kf from '../../kf/kf'
export default {
  components: {  language },
  data() {
    return {
      datass:'11',
      isShow:true,
      isList:false,
      isCar:false,
      itemList:[],
      show: false,
      title: sessionStorage.getItem('title'),
      send:0,
      items: [],
      active: 0,
      activeIndex: 0,
      goodsList:[], //商品列表
      comboList:[],
      searchValue:'', //搜索框中的值
      currentPage: 1, //当前的页数
      allPageCount:1,
      type:'', //当前列表是什么类型的数据
      activeKey:'',
      sendItems: [
        
      ],
      changeItem:'',
      titleList:[],
    };
  },
  computed: {
  },
  created(){
    // debugger
    
        // zE('webWidget', 'show');  //进到页面就启动组件
        //     zE('webWidget', 'setLocale', 'zh-cn'); //设置语言
        //     zE('webWidget', 'identify', {   //设置默认的信息
        //         name: '',
        //         email:'',
        //         phone: '',
        //         tel:'',
        //         organization: 'VIP'
        //     });
        //     zE('webWidget', 'prefill', {
        //         name: {
        //             value: '',
        //             readOnly: false // optional
        //         },
        //         email: {
        //             value: 'isamu@xxx.com',
        //             readOnly: false // optional
        //         },
        //         mobile: {
        //             value: '',
        //             readOnly: true
        //         }
        //     });
  },
  mounted(){
    // debugger
    
    let url = location.host.split('/')[0]
    let reg = sessionStorage.getItem('REG')
    home.index(url,reg).then(res => {
      let REG = res.region
      // sessionStorage.setItem('title',res.title)
      // this.title = res.title
      if(sessionStorage.getItem('REG') == null){
        sessionStorage.setItem('REG',res.region)
      }
      // this.getCategoryInfo(res.region,res.shopId)
      this.$store.commit('user/setIndexData',res)
      let content = JSON.parse(res.content);
      // this.$store.commit("designer/setTitleName", content[0].prop.title);
      // this.title=content[0].prop.title;
      this.I18n(REG)
      kf.importKf()
      setTimeout(()=>{
        zE('webWidget', 'hide');
      },3000)
    })
  },
  destroyed: function () {
    // debugger
    //   zE('webWidget', 'hide');
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    onHome(){
      this.$router.push({path:"/"})
      this.show=false
    },
    gohome(){
      zE('webWidget', 'show');
      zE('webWidget', 'open');
      //  zE('webWidget', 'close');
      zE('webWidget:on', 'close', function() {
        zE('webWidget', 'hide');
      });
        // Dialog.confirm({
        //   message: this.$t("contactUs.callMe") + '<br/>' + this.$t("contactUs.afterShop"),
        //   confirmButtonText:this.$t("contactUs.confirm"),
        //   showCancelButton:false
        // }).then(() => {
            
        // }).catch(() => {
            
        // })
        // this.$router.push({path:"/"})
        // this.show=false
    },
    showCart(){
      this.$router.push({path:"/cart"})
    },
    onNavBar(index){
      // console.info('----------',index,'------------',this.items)
      this.show=false
      this.$router.push({path:"/GoodsCategory",query:{index:index}})
      
    },
    changePay(item,value) {
      // this.titleList.forEach((items,indexs)=>{
      //   if(item ==items.region){
      //     this.title = items.title
      //   }
      // })
      let shopId = sessionStorage.getItem('shopId')
      this.$refs.setRegion.init(item,shopId)
      sessionStorage.setItem('REG',item)
      sessionStorage.removeItem('orderItems')
      // this.$router.push({path:"/"})
      // typeof(exp) == "undefined"
      // console.log(sessionStorage.getItem('OptionVal'))
      // debugger
      let ex = sessionStorage.getItem('OptionVal') 
      if(ex == "undefined"){
        sessionStorage.setItem('OptionVal',0)
      }else{
        sessionStorage.setItem('OptionVal',value)
      }
      let url = location.host;
      home.index(url,item).then(res => {
      sessionStorage.setItem('title',res.title)
      this.title = res.title
      this.$store.commit('user/setIndexData',res)
      // console.log(this.$store.state.user.indexData.region)
      let content = JSON.parse(res.content);
      // this.$store.commit("designer/setTitleName", content[0].prop.title);
      // this.title=content[0].prop.title;
    })
    this.I18n(item)
    // this.getCategoryInfo(item)
    // sessionStorage.setItem('REG',item)
    this.getCategoryInfo()
    },
    showPopup(){
      this.send = Number(sessionStorage.getItem('OptionVal'))
      this.show=true;
      // if(location.href.indexOf('Detail/')!=-1){
      //   this.isShow = false
      // }else{
      //   this.isShow = true
      // }
      // 判断所拥有地区有几个，如果小于2个则不显示
      //传入shopId 请求有几个地区
       goods.regionList(sessionStorage.getItem('shopId')).then(res=>{
         this.titleList= res
         if(res.length<=1 || location.href.indexOf('Detail/')!=-1){
           this.isShow = false
         }else{
           let list = []
           res.forEach((item,index)=>{
             list.push(item.region)
           })
          this.sendItems = list
            let REGList = []
            this.sendItems.forEach((item,index)=>{
            let itemm = {
                text:item,
                value:index
              }
              REGList.push(itemm)
            })
            this.sendItems = REGList
            this.isShow = true
         }
       })
       let url = location.host.split('/')[0]
       let reg = sessionStorage.getItem('REG')
       home.index(url,reg).then(res => {
          let REG = res.region
          // sessionStorage.setItem('title',JSON.parse(res.content)[0].prop.title)
          // sessionStorage.setItem('REG',res.region)
          // this.getCategoryInfo(res.region,res.shopId)
          this.$store.commit('user/setIndexData',res)
          let content = JSON.parse(res.content);
          this.$store.commit("designer/setTitleName", content[0].prop.title);
          // this.title=content[0].prop.title;
          // this.I18n(REG)
        }) 
       this.getCategoryInfo()

    },
    onConfirm(data){
      
    },
    onTop(){
      $("html,body").animate({ scrollTop: "0px" }, 1000);
      // window.scrollTo(0,0);
    },
     getCategoryInfo(){ //産品分類信息列表
      //  goods.categoryInfo({shopId:this.$store.state.designer.shopId,region:region}).then((res) => {
      //    this.itemList=treeDataTranslate(res, "categoryId", "parentId");
      //  })
      // console.log('region',region)
      // console.log('REG',sessionStorage.getItem('REG'))
        goods.categoryInfo({shopId:sessionStorage.getItem('shopId'),region:sessionStorage.getItem('REG')}).then((res) => {
          this.itemList=treeDataTranslate(res, "categoryId", "parentId");
        })
    },
    I18n(item){
      if(item=='台灣'){
        let locale = this.$i18n.locale;
        locale === "null" ? (this.$i18n.locale = "tw") : (this.$i18n.locale = "tw");
        sessionStorage.setItem('locale','tw')
      }else if(item=='Malaysia'){
        let locale = this.$i18n.locale;
        locale === "null" ? (this.$i18n.locale = "ma") : (this.$i18n.locale = "ma");
        sessionStorage.setItem('locale','ma') 
      }else if(item=='日本'){
      let locale = this.$i18n.locale;
        locale === "null" ? (this.$i18n.locale = "ja") : (this.$i18n.locale = "ja");
        sessionStorage.setItem('locale','ja')
      }else if(item=='ประเทศไทย'){
        let locale = this.$i18n.locale;
        locale === "null" ? (this.$i18n.locale = "tg") : (this.$i18n.locale = "tg");
        sessionStorage.setItem('locale','tg')
      }else if(item=='Singapore'){
        let locale = this.$i18n.locale;
        locale === "null" ? (this.$i18n.locale = "en") : (this.$i18n.locale = "en");
        sessionStorage.setItem('locale','en')
      }else if(item=='香港'){
        let locale = this.$i18n.locale;
        locale === "null" ? (this.$i18n.locale = "hk") : (this.$i18n.locale = "hk");
        sessionStorage.setItem('locale','hk')
      }else if(item=='Pilipinas'){
        let locale = this.$i18n.locale;
        locale === "null" ? (this.$i18n.locale = "flb") : (this.$i18n.locale = "flb");
        sessionStorage.setItem('locale','flb')
      }else if(item=='Việt Nam'){
        let locale = this.$i18n.locale;
        locale === "null" ? (this.$i18n.locale = "yn") : (this.$i18n.locale = "yn");
        sessionStorage.setItem('locale','yn')
      }else if(item=='Indonesia'){
        let locale = this.$i18n.locale;
        locale === "null" ? (this.$i18n.locale = "is") : (this.$i18n.locale = "is");
        sessionStorage.setItem('locale','is')
      }
    },
  },
};
</script>
 
<style lang="scss" scoped='scoped'>
      .ld button{
        border:none;
        width: 100%;
      }
      .ld .el-submenu__title i{
          display: none;
      }
      .ld .shows i{
          display: block;
      }
      .ld .heid i{
          display: none;
      }
      .ld .el-col-12{
        width: 100%;
      }
     .on-width{
       width: 40px;
      //  border: solid 1px red;
       position: fixed;
       bottom: 12%;
       right: 5%;
       height: 100px;
       z-index: 999;
     }
    .nav-head{
      // width: 100%;
      position: fixed;
      top: 0;
      z-index: 999;
    }
    .send{
      // border: solid 1px red;
      margin-top: 30%;
    }
    .van-sidebar{
      width: 100%;
    }
    // .bodys{
    //   position: absolute;
    //   right: 0;
    //   top: 0;
    // }
    .van-button--normal {
        padding: 0 34px;
        font-size: 14px;
    }
    .van-tree-select__nav {
        -webkit-box-flex: 2;
        -webkit-flex: 2;
        flex: 2;
        overflow-y: auto;
        background-color: #f7f8fa;
        -webkit-overflow-scrolling: touch;
    }
    .on-top{
      // border: solid 1px #000;
      // background-color: rgba(0,0,0,0.5);
      color: white;
      width: 40px;
      height: 40px;
      z-index: 999;
      border-radius: 50%;
    }
    .on-top i{
      padding: 5px;
    }
    .iconList{
      width:20px;
      height: 20px;
    }
    .van-nav-bar__left,.van-nav-bar__right{
      bottom:13px
    }
    @media screen and (min-width: 750px) {
      .on-width {
        right: 10%!important;
      }
        .home .nav-head {
          width: 750px;
          margin: 0 auto;
      }
    }
    @media screen and (max-width: 750px) {
        .home .nav-head {
          width: 100%;
          margin: 0 auto;
      }
    }
    @media screen and (min-width: 1110px){
      .home .nav-head {
          width: 750;
          margin: 0 auto;
      }
    }

</style>


// WEBPACK FOOTER //
// src/pages/navHead/navIndex.vue